import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class PrestazioneService {

  private apiURL = environment.apiBaseUrl + '/prestazioni/';

  constructor(private http: HttpClient) { }

  /*
  *  Recupera una prestazione dal server sapendo l'id
  */
  show(id: string) {
    return this.http
      .get<{ message: string; prestazione: any }>(
        this.apiURL + id
      );
  }

  /*
  *  Recupera tutte le prestazioni
  */
  index() {
    return this.http
      .get<{ message: string; prestazioni: any }>(
        this.apiURL
      );
  }

}
